export default __webpack_public_path__ + "static/media/image-frame-2.33ccc1c8.jpg";